import { z } from "zod"
import { ProjectRoleSchema } from "@modules/project/_shared/types"

export const ProjectSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  code: z.string().nullable(),
  client: z.string().nullable(),
  owner: z.string().nullable(),
  start_date: z.string().nullable(),
  end_date: z.string().nullable(),
  is_active: z.boolean(),
  role: ProjectRoleSchema,
  is_client_owner: z.boolean().optional().nullable(),
  folder_id: z.string(),
})

export type TProject = z.infer<typeof ProjectSchema>

export type TProjectContext = {
  project: TProject;
  projectId: string;
  role: TProject["role"];
  rootFolderId: string;
};
